import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import { FaCheckCircle, FaTimesCircle, FaPencilAlt, FaClock } from "react-icons/fa"; // Import icons
import axios from "../../../axiosInstance";

import "./Dashboard_rp.css";
import AdsBanner from "../../AdsBanner/AdsBanner";

function Dashboard() {
  const [counts, setCounts] = useState({
    published: 0,
    rejected: 0,
    drafts: 0,
    approvalpending: 0,
  });
  const [views, setViews] = useState({
    totalViews: 0,
    viewsThisMonth: 0,
    viewsToday: 0,
  });
  const [loading, setLoading] = useState(true);
  const ID = localStorage.getItem("reporterId"); // Assuming reporterId is stored in localStorage
  const token = localStorage.getItem("sessiontoken"); // Get the token from localStorage

  useEffect(() => {
    const fetchCountsAndViews = async () => {
      try {
        // Sending the token in Authorization header
        const [statusResponse, viewsResponse] = await Promise.all([
          axios.get(`/api/news/status/count?reporterId=${ID}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the header
            },
          }),
          axios.get(`/api/news/status/views?reporterId=${ID}`, {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the header
            },
          }),
        ]);

        setCounts(statusResponse.data);

        // Assuming viewsResponse contains { todayViews, viewsThisMonth, totalViews }
        setViews({
          totalViews: viewsResponse.data.totalViews || 0,
          viewsThisMonth: viewsResponse.data.monthViews || 0,
          viewsToday: viewsResponse.data.todayViews || 0,
        });
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountsAndViews();
  }, [ID, token]); // Re-run when ID or token changes

  return (
    <div>
      <Sidebar />

      <div className="dashboard-container">
        <div className="dashboard-content">
          <AdsBanner placement="Header" page="News" />

          <h1 className="dashboard-title">Dashboard</h1>

          {/* Display loading spinner while fetching data */}
          {loading ? (
            <div className="loading-spinner">
              <p>Loading...</p>
            </div>
          ) : (
            <div className="dashboard-stats">
              <div className="stat-card">
                <FaCheckCircle className="stat-icon-1" />
                <h3>Published</h3>
                <p>{counts.published}</p>
              </div>

              <div className="stat-card">
                <FaTimesCircle className="stat-icon-2" />
                <h3>Rejected</h3>
                <p>{counts.rejected}</p>
              </div>

              <div className="stat-card">
                <FaClock className="stat-icon-3" />
                <h3>Approval Pending</h3>
                <p>{counts.approvalpending}</p>
              </div>
            </div>
          )}

          {/* Views Section */}
          <div className="views-section">
            <h3>Views Status</h3>
            <div className="views-display">
              <div className="views-box">
                <h4>Total Views</h4>
                <p>Coming soon!</p>
              </div>
              <div className="views-box">
                <h4>Month Views</h4>
                <p>{views.viewsThisMonth}</p>
              </div>
              <div className="views-box">
                <h4>Today Views</h4>
                <p>{views.viewsToday}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
